var mockData = {
  DCA: [
    {
      OriginatorCreditId: "abc132sdf",
      NextPaymentNumber: 2,
      RemainingPrincipal: 1234.0,
    },
    {
      OriginatorCreditId: "lsysdca-12312312313212345asdasd",
      NextPaymentNumber: 2,
      RemainingPrincipal: 20000.0,
    },
  ],
  UCReports: [
    {
      Month: 12,
      Year: 2017,
    },
    {
      Month: 11,
      Year: 2017,
    },
  ],
  Applications: [
    {
      Id: "95b854df-c9de-46f7-aa33-3e6fd8865515",
      AccountId: "93074937-9070-222a-756f-9e3dfcb48fbc",
      Identity: "4b77dda1-48a8-e91e-b86c-86943cf2552e",
      LoanOffers: [
        {
          Id: "214178e8-2d14-40c1-9388-1103c17d3f19",
          OfferType: 0,
          Accepted: true,
          DateAccepted: "2017-08-25T10:57:11.2384628Z",
          LoanAmount: { Amount: 15000.0 },
          LoanTerm: 0,
          NominalInterest: { Value: 0.02361 },
          EffectiveInterest: { Value: 0.149 },
          IntermediationFeeRate: { Value: 0.02677 },
          Annuity: { Amount: 640.48 },
          InvoiceFee: { Amount: 60.0 },
          TimeStamp: "0001-01-01T00:00:00",
        },
        {
          Id: "0f16d0cc-6820-431d-9704-1103c17d3f1a",
          OfferType: 1,
          Accepted: false,
          DateAccepted: "0001-01-01T00:00:00",
          LoanAmount: { Amount: 50000.0 },
          LoanTerm: 0,
          NominalInterest: { Value: 0.02361 },
          EffectiveInterest: { Value: 0.08 },
          IntermediationFeeRate: { Value: 0.02677 },
          Annuity: { Amount: 2134.95 },
          InvoiceFee: { Amount: 60.0 },
          TimeStamp: "0001-01-01T00:00:00",
        },
      ],
      Stage: 3,
      AppliedAmount: { Amount: 15000.0 },
      AppliedTerm: 24,
      LivingCosts: { Amount: 5000.0 },
      HousingCosts: { Amount: 5000.0 },
      Income: { Amount: 50000.0 },
      HouseholdAdults: 1,
      HouseholdChildren: 0,
      CreditsMonthlyCosts: { Amount: 0.0 },
      EmploymentStatus: 4,
      EmployedMonths: 18,
      CreditPurpose: null,
      IsPep: false,
      DirectDebitAccountId: "b008e02f-cdf4-1d44-9df9-018e73383198",
      DateStarted: "2017-08-25T10:45:50.4640336Z",
      DateSubmitted: "2017-08-25T10:56:21.0817432Z",
      TimeStamp: "0001-01-01T00:00:00",
    },
    {
      Id: "f0a838bf-dc08-4300-a07c-f710b2026b23",
      AccountId: "ea4036fd-e984-0a7f-3cc4-db354f50df34",
      Identity: "5223dbcc-6f37-2bc2-f38f-56e36effca26",
      LoanOffers: [
        {
          Id: "53ba7b36-98d8-470a-9849-1103c0b6d434",
          OfferType: 0,
          Accepted: false,
          DateAccepted: "0001-01-01T00:00:00",
          LoanAmount: { Amount: 20000.0 },
          LoanTerm: 0,
          NominalInterest: { Value: 0.04817 },
          EffectiveInterest: { Value: 0.233 },
          IntermediationFeeRate: { Value: 0.02861 },
          Annuity: { Amount: 3380.32 },
          InvoiceFee: { Amount: 60.0 },
          TimeStamp: "0001-01-01T00:00:00",
        },
        {
          Id: "058f7ff8-548c-48cf-bd8e-1103c0b6da61",
          OfferType: 1,
          Accepted: true,
          DateAccepted: "2017-08-25T10:54:44.6950159Z",
          LoanAmount: { Amount: 50000.0 },
          LoanTerm: 0,
          NominalInterest: { Value: 0.04817 },
          EffectiveInterest: { Value: 0.189 },
          IntermediationFeeRate: { Value: 0.02861 },
          Annuity: { Amount: 8450.8 },
          InvoiceFee: { Amount: 60.0 },
          TimeStamp: "0001-01-01T00:00:00",
        },
      ],
      Stage: 3,
      AppliedAmount: { Amount: 20000.0 },
      AppliedTerm: 6,
      LivingCosts: { Amount: 5000.0 },
      HousingCosts: { Amount: 5000.0 },
      Income: { Amount: 50000.0 },
      HouseholdAdults: 1,
      HouseholdChildren: 1,
      CreditsMonthlyCosts: { Amount: 1000.0 },
      EmploymentStatus: 3,
      EmployedMonths: 12,
      CreditPurpose: null,
      IsPep: false,
      DirectDebitAccountId: "e5c3469e-6df6-bf8f-aeae-83d304a85394",
      DateStarted: "2017-07-24T10:51:57.1118816Z",
      DateSubmitted: "2017-07-24T10:54:13.662511Z",
      TimeStamp: "0001-01-01T00:00:00",
    },
  ],
  Deposits: [
    {
      HighRiskFlag: false,
      Id: "046b7f51-711a-41d8-ab97-1103d01ca765",
      AccountId: "990b2993-1db8-bf3a-03d6-255fb088824d",
      DepotId: "05b00c25-e411-a8ea-09b6-f4b4ed24fdbe",
      RefCode: "01d7d5",
      Amount: { Amount: 100000.0 },
      OrderDate: "2017-08-25T11:36:54.1898621Z",
      OrderStatus: 0,
      TimeStamp: "0001-01-01T00:00:00",
    },
    {
      HighRiskFlag: false,
      Id: "046b7f51-711a-41d8-ab97-1103d01ca765",
      AccountId: "990b2993-1db8-bf3a-03d6-255fb088824d",
      DepotId: "05b00c25-e411-a8ea-09b6-f4b4ed24fdbe",
      RefCode: "01d7d5",
      Amount: { Amount: 100000.0 },
      OrderDate: "2017-07-24T11:36:54.1898621Z",
      OrderStatus: 0,
      TimeStamp: "0001-01-01T00:00:00",
    },
  ],
  Users: [
    {
      Id: "Test",
      IdentityName: {
        FullName: "Test Test",
        Name: "Test",
        LastName: "Test",
      },
      Emails: [
        {
          EmailAddress: "test@test.com",
        },
      ],
      CellPhones: [
        {
          PhoneNumber: 701123123,
        },
      ],

      Addresses: [
        {
          Street: "Test street",
          City: "Test city",
          PostalCode: "90-900",
          Region: "Test region",
          Country: "Sweden",
          CountryCode: "sv",
        },
      ],
    },
  ],
  InvestorDepositsMatched: [
    {
      DepotId: "6ae33b3f-a978-48fc-9652-2e42a3738a49",
      Ocr: "5919775048",
      InvestorName: null,
      Amount: 500,
      DepotName: null,
      Id: "5ffc3476-5e64-4530-a843-50e83a44a281",
      TimeStamp: "0001-01-01T00:00:00",
    },
  ],
};

export default mockData;
